import { render, staticRenderFns } from "./ReviewDomain.vue?vue&type=template&id=10cc0278&scoped=true"
import script from "./ReviewDomain.vue?vue&type=script&lang=js"
export * from "./ReviewDomain.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomain.vue?vue&type=style&index=0&id=10cc0278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc0278",
  null
  
)

export default component.exports